<template>
  <div>
    <label style="display: flex; position: relative; align-items: center">
      <ml-input class="w-full h-full" style="border-radius: 5px" :readonly="readonly" :value="inputValue" @click="handleClickInput" />
      <vs-icon v-if="!readonly" icon-pack="feather" icon="icon-users" style="padding-left: 6px; padding-right: 6px; position: absolute; top: auto; right: 0; bottom: auto; font-size: 24px; border-left: 1px solid #cdcdcd"></vs-icon>
    </label>

    <popup-search-employee v-model="showPopup" :listOnly="listOnly" :selectId="selectCompany ? selectCompany.id : selectEmployeeId" :field-id="fieldId" @handleClickSelect="handleClickSelect" />
  </div>
</template>

<script>
import PopupSearchEmployee from "@/popup/PopupSearchEmployee";

export default {
  name: "EmployeeSelector",
  components: { PopupSearchEmployee },
  props: {
    value: [Number, String],
    useName: Boolean,
    readonly: Boolean,
    listOnly: {
      type: Boolean,
      default: () => true,
    },
    fieldId: Number,
  },
  watch: {
    value(data) {
      this.value = data;
    },
  },
  computed: {
    selectCompany() {
      const list = this.$store.state.employee.employeeList;
      return list.find((item) => item.employee_id === this.value);
    },
    inputValue() {
      if (!!this.selectCompany) {
        if (this.useName) return this.selectCompany.full_name;
        else return this.selectCompany.employee_id;
      }
    },
  },
  data() {
    return {
      showPopup: false,
      selectEmployeeName: "",
      selectEmployeeId: "",
    };
  },
  created() {},
  methods: {
    handleClickInput() {
      if (!this.readonly) {
        this.showPopup = true;
      }
    },

    handleClickSelect(employee) {
      if (this.readonly) {
        // 읽기 전용일 때에는 선택 동작으로 넘어가지 않게 핟나
        return;
      }
      this.selectEmployeeName = employee[0].full_name;
      this.selectEmployeeId = employee[0].employee_id;
      if (this.useName) this.$emit("input", this.selectEmployeeName);
      else this.$emit("input", this.selectEmployeeId);
      this.$emit("select", employee[0]);
    },
  },
};
</script>

<style scoped></style>
